import forResponse from '../utils/forResponse';
import { EMAIL_CHECK, EMAIL_VERIFY } from '../constants/apiUrls/apiUrls';

import http from './http/index';


export const validateEmailAddress = (payload) => forResponse(http.post(EMAIL_CHECK, payload));

export const verifyEmailAddress = (token) => {
  const url = EMAIL_VERIFY.replace('{token}', encodeURIComponent(token));

  return forResponse(http.put(url));
};
